import { render, staticRenderFns } from "./CurrentAvailabilityTable.vue?vue&type=template&id=5d1afa85&scoped=true&"
import script from "./CurrentAvailabilityTable.vue?vue&type=script&lang=js&"
export * from "./CurrentAvailabilityTable.vue?vue&type=script&lang=js&"
import style0 from "./CurrentAvailabilityTable.vue?vue&type=style&index=0&id=5d1afa85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1afa85",
  null
  
)

export default component.exports